import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.less']
})
export class QrCodeComponent {
  private readonly whatsappNumber = '27664532826';

  public message = 'I would like a quote from my nearest Autowiel fitment centre.';
  public url = '';
  public isVisible = false;
  public hasUrlError = false;
  public hasMessageError = false;

  @ViewChild('downloadLink', { static: false }) downloadLink!: ElementRef<HTMLAnchorElement>;

  public createWhatsAppUrl(): void {
    const message = this.message.trim();

    this.hasMessageError = !message;

    if (this.hasMessageError) {
      return;
    }

    this.url = `https://wa.me/${this.whatsappNumber}/?text=${encodeURIComponent(message)}`;
    this.hasUrlError = false;
    this.isVisible = false;
  }

  public onUrlChange(): void {
    this.hasUrlError = false;
    this.isVisible = false;
  }

  public generateQRCode(): void {
    const url = this.url.trim();
    this.hasUrlError = !url;

    if (this.hasUrlError) {
      this.isVisible = false;
      return;
    }

    this.url = url;
    this.isVisible = true;
  }

  public downloadQrCode(): void {
    const canvas = document.getElementById('download')?.querySelector<HTMLCanvasElement>('canvas');

    if (canvas) {
      this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
      this.downloadLink.nativeElement.download = 'qr-code.png';
      this.downloadLink.nativeElement.dispatchEvent(new MouseEvent('click'));
    }
  }
}
